/**
 * Progress Bar Component
 *
 * Displays the like gauge progress bar with heart icon.
 */

import React from 'react';
import './ProgressBar.css';

interface ProgressBarProps {
    progress?: number; // 0-100
    showRainbow?: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
    progress = 0,
    showRainbow = false
}) => {
    // ゲージ表示高さ（フレームに収める）
    const displayHeight = progress * 0.9;

    return (
        <>
            {/* Heart Icon */}
            <div
                id="heart-icon-overlay"
                className="heart-icon-overlay"
                style={{ top: `${46.4 - (progress * 0.15)}%` }}
            >
                <img src="/assets/UI/img_bar3.png" alt="Heart" />
            </div>

            {/* Progress Container */}
            <div id="custom-progress-container" className="progress-container">
                {/* Gauge Fill */}
                <div
                    id="custom-gauge-fill"
                    className="gauge-fill"
                    style={{ height: `${displayHeight}%` }}
                >
                    <img
                        id="gauge-image"
                        src="/assets/UI/img_bar1.png"
                        alt="Bar Gauge"
                        className="gauge-image"
                        style={{ height: '100%' }}
                    />
                    {/* Rainbow Gradient Bar */}
                    <div
                        id="rainbow-gauge-bar"
                        className={`rainbow-gauge-bar ${showRainbow ? 'visible' : ''}`}
                        style={{ height: '100%' }}
                    />
                </div>

                {/* Frame */}
                <img
                    id="custom-bar-frame"
                    src="/assets/UI/img_bar2.png"
                    alt="Bar Frame"
                    className="bar-frame"
                />
            </div>
        </>
    );
};

export default ProgressBar;
